import { Injectable, inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
  UrlTree
} from '@angular/router';

import { AuthService } from '../services/auth.service';
import { SESSION_UNAVAILABLE_RETURN_PARAM } from '../session-unavailable/session-unavailable.component';

/**
 * Wraps every route but /unavailable. While the API cannot say who is signed
 * in, every navigation goes to the can't-reach page instead, which returns to
 * the URL it was given once the API answers. It runs ahead of every other
 * guard, so none of them mistakes "unknown" for "signed out".
 */
@Injectable({
  providedIn: 'root'
})
export class SessionAvailableGuard {
  private readonly authService = inject(AuthService);
  private readonly router = inject(Router);

  public canActivateChild(
    _route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | UrlTree {
    if (!this.authService.sessionUnavailable()) {
      return true;
    }
    return this.router.createUrlTree(['/unavailable'], {
      queryParams: { [SESSION_UNAVAILABLE_RETURN_PARAM]: state.url }
    });
  }
}
